<template>
  <div class="home_page">
		<el-container style="height: 100%;">
			<el-header style="background: #0e8def;">
				<div class="admin-top">
					<div class="title">「展翅计划香港大学生实习专项」管理后台</div>
					<div class="user">
						<span>{{ username }}，欢迎你！</span> | <span style="color: #FE78D1;" @click="logout">退出</span>
					</div>
				</div>
			</el-header>
			<el-container>
				<el-aside width="200px" style="background-color: rgb(81, 81, 81)">
					<div class="right-banner">
						<el-menu  class="el-menu-vertical-demo"
											background-color="#515151"
											text-color="#fff"
											:unique-opened="true"
											:router="true"
											:default-active="activeRoute"
											active-text-color="#4c7fff">
							<el-menu-item index="company">
								<i class="el-icon-s-home"></i>
								<span slot="title">企业管理</span>
							</el-menu-item>
							<el-menu-item index="position">
								<i class="el-icon-s-cooperation"></i>
								<span slot="title">岗位管理</span>
							</el-menu-item>
							<el-menu-item index="student">
								<i class="el-icon-user-solid"></i>
								<span slot="title">学生管理</span>
							</el-menu-item>
						</el-menu>
					</div>
				</el-aside>
				<el-container>
					<el-main>
						<div class="left-content">
							<router-view></router-view>
						</div>
					</el-main>
				</el-container>
			</el-container>
		</el-container>
  </div>
</template>

<script>
import { removeLocalStorage } from '../utils/localStorage.js';
export default {
  name: 'home',
	data() {
		return {
			activeRoute: this.$route.name,
			username: window.localStorage.getItem('username'),
		}
	},
  components: {

  },
	created() {
		
	},
	methods: {
		logout() {
			removeLocalStorage();
			this.$router.push({ path: '/login'});
		}
	}
}
</script>
<style lang="less">
	.home_page{
		height: 100%;
		.admin-top{
			height: 60px;
			width: 100%;
			min-width: 1200px;
			color: #fff;
			background: #4c7fff;
			.title{
				float: left;
				font-size: 20px;
				line-height: 60px;
			}
			.user{
				float: right;
				font-size: 16px;
				height: 60px;
				margin-right: 30px;
				line-height: 60px;
				span{
					&:last-child{
						cursor: pointer;
					}
				}
			}
		}
		.right-banner{
			.el-menu-vertical-demo{
				height: 100%;
			}
		}
		.left-content{
			box-sizing: border-box;
			background: #ffffff;
		}
	}
</style>
